export const lensAddresses = {
  accountLens: "0x99Cf844584BBFa12E6b76a9FD3C08C2Dd99F87C4",
  eulerEarnVaultLens: "0xAF21D9674CDc8aDb2AC184AC1Fbfa372a7b19180",
  irmLens: "0x59a3C9F50d1357b06Eda2f40e2E57DB03988b05F",
  oracleLens: "0x6Ed14a85CEF0048C57Cb13c2Eb5435eA723e8123",
  utilsLens: "0xE05BB9159c4B663c9A56320C5Aa96a59560C5Bbc",
  vaultLens: "0x4c7BA548032FE3eA11b7D6BeaF736B3B74F69248",
} as const
